<section class="institute-wrap">
  <div class="wrap-lg">
    <div class="institute-inner">
      <div class="nav-sec">
        <div class="back-nav" (click)="back()">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M15 6L9 12L15 18" stroke="#1A204B" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span class="nav-name">Back</span>
        </div>
      </div>
      <div class="page-head mob-stick">
        <div class="head-left">
          <div class="page-title">Select Your {{isSF?'School': 'Institute'}} <span class="wrap-text">From The List</span></div>
        </div>

        <div class="head-right">
          <div *ngIf="util.getCache('cityApiRes') != null && isSF ">
          <div class="cus-dropdown location-drop" (click)="openDrop('location_drop')">
            <svg class="location-icon" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M17.1829 7.04171C16.3079 3.19171 12.9496 1.45837 9.99959 1.45837C9.99959 1.45837 9.99959 1.45837 9.99126 1.45837C7.04959 1.45837 3.68292 3.18337 2.80792 7.03337C1.83292 11.3334 4.46626 14.975 6.84959 17.2667C7.73292 18.1167 8.86626 18.5417 9.99959 18.5417C11.1329 18.5417 12.2663 18.1167 13.1413 17.2667C15.5246 14.975 18.1579 11.3417 17.1829 7.04171ZM9.99959 11.2167C8.54959 11.2167 7.37459 10.0417 7.37459 8.59171C7.37459 7.14171 8.54959 5.96671 9.99959 5.96671C11.4496 5.96671 12.6246 7.14171 12.6246 8.59171C12.6246 10.0417 11.4496 11.2167 9.99959 11.2167Z" fill="#545E65"/>
            </svg>
            <input class="cus-input" type="text" [(ngModel)]="selectedLocation" (input)="selectLocation(selectedLocation,false)"  placeholder="Select Location" readonly />
            <div id="location_drop" class="drop-content" >
              <div *ngFor="let city of util.getCache('cityApiRes')" class="drop-item" (click)="selectLocation(city)">{{city.value}}, {{city.stateInfo.value}}</div>
            </div>
          </div>
        </div>

        <div class="page-search" *ngIf=" !isSF">
          <input type="text" class="cus-input" [(ngModel)]="searchTerm" (input)="onInputChange()"
          placeholder="Search for institutes"/>
          <svg class="search-icon" width="48" height="40" viewBox="0 0 48 40" fill="none" >
            <path d="M3.08964 10.2988C1.54977 5.16589 5.39334 0 10.7522 0H40C44.4183 0 48 3.58172 48 8V32C48 36.4183 44.4183 40 40 40H17.9522C14.4194 40 11.3048 37.6827 10.2896 34.2988L3.08964 10.2988Z" fill="#17151C"/>
            <path d="M27.6 27.2C31.7974 27.2 35.2 23.7974 35.2 19.6C35.2 15.4026 31.7974 12 27.6 12C23.4026 12 20 15.4026 20 19.6C20 23.7974 23.4026 27.2 27.6 27.2Z" stroke="#10D7EE" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M36.0002 28L33.2002 25.2" stroke="#10D7EE" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>

      </div>
      </div>
      <div class="institute-list">
        <div [class]=" isLessElements ? 'institute-item1': 'institute-item'" *ngFor="let institute of instituteList,let i = index">
          <div class="institute-top" (click)=" util.isMobile ? isSF ? studentDetail(institute,i): openCourses(institute,i) :'' " >
            <div class="institute-icon">
              <img [src]="'data:image/png;base64,'+ (institute?.image64 || institute?.address1)" [alt]="institute.name"/>
            </div>
            <div class="gradient-line-hr" *ngIf="isLessElements"></div>
            <div>
              <div class="institute-name">{{institute.name}}</div>


              <div class="institute-location">
                <svg width="20" height="19" viewBox="0 0 20 19" fill="none">
                  <path d="M16.5432 6.74109C15.7468 3.2371 12.6903 1.65955 10.0054 1.65955C10.0054 1.65955 10.0054 1.65955 9.99784 1.65955C7.32055 1.65955 4.25646 3.22951 3.4601 6.7335C2.57273 10.647 4.96939 13.9614 7.13853 16.0471C7.94247 16.8207 8.97395 17.2075 10.0054 17.2075C11.0369 17.2075 12.0684 16.8207 12.8647 16.0471C15.0339 13.9614 17.4305 10.6546 16.5432 6.74109ZM10.0054 10.5409C8.68574 10.5409 7.61635 9.47147 7.61635 8.15178C7.61635 6.8321 8.68574 5.7627 10.0054 5.7627C11.3251 5.7627 12.3945 6.8321 12.3945 8.15178C12.3945 9.47147 11.3251 10.5409 10.0054 10.5409Z" fill="#DDE2E3"/>
                </svg>{{institute.city}}, {{institute.state}}
              </div>
            </div>
          </div>
          <svg class="mob-show arrow" (click)=" isSF ? studentDetail(institute,i): openCourses(institute,i)" width="20" height="21" viewBox="0 0 20 21" fill="none">
            <path d="M8.63379 5.60367L13.549 10.5189L8.63379 15.4341" stroke="#17151C" stroke-width="1.82195" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <button class="btn-primary mob-hide" *ngIf="!isSF" (click)="openCourses(institute,i)">View  {{institute?.noOfCourses}} Courses</button>
          <button class="btn-primary mob-hide"*ngIf="isSF" (click)="studentDetail(institute,i)">APPLY</button>
        </div>
      </div>
      <app-no-results *ngIf="totalPages == 0"></app-no-results>
      <div class="pagination-sec" *ngIf="totalPages != 0">
        <div class="pagi-btn prev " [class.disable]="currentPage === 0 " (click)="prevPage()"><img src="assets/images/icons/right_arrow_black.svg" alt="Arrow"/></div>
        <div class="pagi-btn active">{{currentPage+1}}/{{totalPages}}</div>
        <div class="pagi-btn next" [class.disable]="currentPage === totalPages - 1" (click)="nextPage()"><img src="assets/images/icons/right_arrow_black.svg" alt="Arrow"/></div>
      </div>
    </div>
  </div>
</section>
